import {
    createContext,
    useContext,
    useState,
    ReactNode,
    useCallback
} from 'react'
import { ModalContext as ModalContextType } from './types'

const ModalContext = createContext<ModalContextType | undefined>(undefined)

type ModalProviderProps = {
    children: ReactNode
    defaultOpen?: boolean
}

export const ModalProvider = ({
    children,
    defaultOpen = false
}: ModalProviderProps) => {
    const [isOpen, setIsOpen] = useState(defaultOpen)

    const open = useCallback(() => setIsOpen(true), [])
    const close = useCallback(() => setIsOpen(false), [])

    return (
        <ModalContext.Provider value={{ isOpen, open, close }}>
            {children}
        </ModalContext.Provider>
    )
}

export const useModal = (): ModalContextType => {
    const context = useContext(ModalContext)
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider')
    }
    return context
}
